import React from "react";
import { Box, Text, TextLink } from "@origin-digital/ods-core";

const CaptchaDisclaimer = () => {
  return (
    <Box paddingTop="none">
      <Text tone="neutralLight" variant="body-small">
        This site is protected by reCAPTCHA and the Google{" "}
        <TextLink
          data-id="captcha-privacy-link"
          href="https://policies.google.com/privacy"
          target="_blank"
        >
          Privacy Policy
        </TextLink>{" "}
        and{" "}
        <TextLink
          data-id="captcha-terms-link"
          href="https://policies.google.com/terms"
          target="_blank"
        >
          Terms of Service
        </TextLink>{" "}
        apply.
      </Text>
    </Box>
  );
};

export { CaptchaDisclaimer };
